import { apiFetch } from './prospects.js';

export async function fetchVideos() {
  return apiFetch('/videos');
}

export async function uploadVideo(formData) {
  return apiFetch('/videos', {
    method: 'POST',
    body: formData,
  });
}

export async function getVideoSignedUrl(id) {
  return apiFetch(`/videos/${encodeURIComponent(id)}/url`);
}

export async function deleteVideo(id) {
  return apiFetch(`/videos/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}
